// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-left-column';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.133 6.866 1 9m0 0 2.133 2.133M1 9h10.666m5.333-8h-4.266a1.067 1.067 0 0 0-1.067 1.067v13.866A1.067 1.067 0 0 0 12.733 17h4.266'
  />
);

export const viewBox = '0 0 18 18';
